import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Grid, makeStyles, Typography } from '@material-ui/core'
import HelpRounded from '@material-ui/icons/HelpRounded'
import * as d3 from 'd3'
import charts from '../data/creditAnalysisChart'
import PageSection from '../components/PageSection'
import ChartDialog from '../components/ChartDialog'
import expandIcon from '../assets/images/expandNew.svg'
import ChartD3ToggleGroup from '../components/ChartD3ToggleGroup'
import { Context as PortfolioContext } from '../contexts/portfolio'
import { getCookie } from '../ultils/cookie'
import FilterBoxCommon from '../components/FilterBoxCommon'
import PoDChart from '../components/PoDChart'
import DriverChart from '../components/DriverChart'
import { TOGGLE_INDEX } from '../ultils/chart-d3-utils'
import PoDTooltipModal from '../components/PoDTooltipModal'
import DriverTooltipModal from '../components/DriverTooltipModal'
import ImpliedRatingChart from '../components/ImpliedRatingChart'
import { isMobile } from 'react-device-detect'

let _ = require('lodash')

export const filterData = [
  { id: 0, value: '2 years' },
  { id: 1, value: '5 years' },
  { id: 2, value: '10 years' },
]

const useStyles = makeStyles({
  chartDiv: {
    position: 'relative',
    '&:hover .tooltip': {
      visibility: 'visible',
    },
    padding: '8px 0px 0px 0px !important',
  },
  subheadingTitle: {
    marginRight: 7,
  },
  subheading: {
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '22px',
    color: '#181818',
    display: 'flex',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    alignItems: 'center',
    '& img': {
      width: 12,
      height: 12,
      marginLeft: 10,
      cursor: 'pointer',
    },
  },
  subTitle: {
    fontSize: 10,
    fontWeight: 600,
  },
  title: {
    lineHeight: '24px',
    fontWeight: 400,
    color: '#181818',
    marginRight: 5,
    marginTop: 10,
  },
  help: {
    display: 'flex',
    alignItems: 'center',
    '& > div': {
      fontSize: 14,
      display: 'flex',
      alignItems: 'center',
      whiteSpace: 'nowrap',
    },
    '& svg': {
      // width: 20,
      // height: 20,
      // marginLeft: 5,
      // cursor: 'pointer',
      // color: '#474747',
    },
  },
  smallLineChart: {
    height: '126px',
    maxWidth: '100%',
    position: 'relative',
  },
  fullLineChart: {
    height: 'calc(100% - 100px)',
    maxWidth: '100%',
  },
  impliedRatingChartDiv: {
    height: '126px',
    maxWidth: '100%',
    position: 'relative',
  },
  fullStackAreaChart: {
    height: 'calc(100% - 100px)',
    maxWidth: '100%',
  },
  marketContextContainer: {
    // margin: '0px 0px 0px -12px',
    margin: 'unset !important',
    width: '100%',
    background: '#fff',
    '& .MuiGrid-item': {
      // padding: '16px 12px 0px 12px',
    },
  },
  chartHeader: {
    color: '#474747',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginBottom: -10,
  },
  expandIcon: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    color: '#1B3963',
    background: '#EDF2F7',
    borderRadius: 4,
    width: 32,
    height: 32,
    '& img': {
      width: 32,
      height: 32,
    },
    '& svg': {
      width: 32,
    },
  },
  menuDateGroup: {
    '& .MuiPaper-root': {
      '& .MuiList-root': {
        padding: 0,
        borderRadius: 'unset',
        '& .MuiButtonBase-root': {
          minHeight: 'unset',
          fontSize: 14,
          lineHeight: '18px',
          fontWeight: 'normal',
          color: '#474747',
        },
      },
    },
  },
  formControlDate: {
    marginLeft: 20,
    width: '100%',
    minWidth: 190,
    '& .MuiFormLabel-root': {
      fontSize: 12,
      lineHeight: '18px',
      transform: 'none',
      marginBottom: 8,
      position: 'unset',
    },
    '& .MuiInputBase-root': {
      height: 40,
      marginTop: 'unset',
      backgroundColor: '#F4F5F7',
      borderRadius: '3px',
      display: 'unset',
      '& .MuiSelect-root': {
        height: '100%',
        fontSize: 14,
        lineHeight: '18px',
        fontWeight: 400,
        color: '#474747',
        padding: '0px',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        backgroundColor: 'transparent !important',
        paddingLeft: 10,
      },
      '& svg': {
        position: 'absolute',
        right: 10,
        top: 6,
        width: 9,
        transform: 'rotate(180deg)',
      },
    },
    '& .MuiInput-underline:after': {
      display: 'none',
    },
    '& .MuiInput-underline:before': {
      display: 'none',
    },
  },
  legend: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    fontSize: 10,
    padding: '20px 0px 17px 0px',
    '& > div': {
      display: 'flex',
      alignItems: 'center',
      marginRight: 16,
      '& div': {
        marginRight: 4,
        width: 8,
        height: 8,
        borderRadius: '50%',
      },
    },
  },
  composition: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 40,
  },
  label: {
    fontSize: 14,
    lineHeight: '18px',
    marginRight: 16,
  },
  filterYearContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  filterTitlte: {
    fontSize: 12,
    lineHeight: '24px',
    fontWeight: 400,
    color: '#474747',
    marginRight: 16,
  },
  customToggleContainer: {
    paddingLeft: 0,
  },
  viewByTitle: {
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 400,
    color: '#474747',
    marginRight: 16,
  },
  toggleBtnContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  compositionComplex: {
    paddingTop: 16,
  },
  toggleContainer: {
    paddingLeft: '0px !important',
    paddingRight: '0px !important',
    padding: '16px 0px 0px 0px !important',
  },
  toolTip:  {
    color: '#8D9CB1 !important',
    margin: 'auto',
    fontSize: '1.3rem',
    cursor: 'pointer',
    marginLeft: '5px',
  }
})

const FundamentalsCreditAnalysisMobile = ({ companyInfo, riskStatus }) => {
  const classes = useStyles()
  const { state } = useContext(PortfolioContext)
  const [viewBy, setViewBy] = React.useState(null)
  const [isOpenExpandModal, setOpenExpandModal] = React.useState(false)
  const [chartDetail, setChartDetail] = React.useState({})
  const [chartsData, setChartsData] = useState(charts)
  const [podToggleObj, setPodToggleObj] = useState({
    showCompanyHistory: true,
    showPeerGroup: false,
    showEquityPrice: false,
  })

  const [driverToggleObj, setDriverToggleObj] = useState({
    showAssetVolatility: false,
    showLeverage: false,
    showMarketValueOfAssets: true,
  })

  const [openTooltip, setOpenTooltip] = React.useState(false)
  const [tooltipInfo, setTooltipInfo] = React.useState({})
  const handleClickOpenTooltip = chart => {
    setOpenTooltip(chart.id)
    setTooltipInfo(chart.tooltipInfo)
  }
  const showImpliedRating = getCookie('implied_rating_flag') !== 'False'

  useEffect(() => {
    if (state?.creditData) {
      const chartCopied = chartsData
      chartCopied.pod.data = state.creditData?.pod ?? []
      chartCopied.driver.data = state.creditData?.driver ?? []
      chartCopied.impliedRating.data = state.creditData?.impliedRating ?? []
      setChartsData(chartCopied)
    }
  }, [state.creditData])

  useEffect(() => {
    const chartsCopy = _.cloneDeep(charts)
    const chartFilterData = filterChartProps(chartsCopy) // chartsCopy.map(i => filterChartProps(i))
    setChartsData(chartFilterData)
    if (chartDetail.id) {
      setChartDetail(chartFilterData[chartDetail.id])
    }
  }, [podToggleObj, driverToggleObj, isOpenExpandModal])

  const filterChartProps = charts => {
    const chartCopy = _.cloneDeep(charts)
    for (const chartId in chartCopy) {
      const chart = chartCopy[chartId]
      const { lineKeys } = chart

      chart.data.map(data => {
        if (chart.id === 'pod') {
          !podToggleObj.showCompanyHistory && delete data[`${lineKeys[0]}`]
          !podToggleObj.showPeerGroup && delete data[`${lineKeys[1]}`]
          !podToggleObj.showEquityPrice && delete data[`${lineKeys[2]}`]
        } else if (chart.id === 'driver') {
          !driverToggleObj.showAssetVolatility && delete data[`${lineKeys[0]}`]
          !driverToggleObj.showLeverage && delete data[`${lineKeys[1]}`]
          !driverToggleObj.showMarketValueOfAssets &&
            delete data[`${lineKeys[2]}`]
        }
      })
    }
    return chartCopy
  }

  const handeExpandChart = chart => {
    setChartDetail(chartsData[chart.id])
    setViewBy(chart.id)
    setOpenExpandModal(true)
  }

  const handleChangeViewBy = val => {
    // TODO: NEED fix change view_by
    setViewBy(val.value)
    const chartsCopy = _.cloneDeep(chartsData)
    const chartFilterData = filterChartProps(chartsCopy) // chartsCopy.map(i => filterChartProps(i))
    for (const c in chartFilterData) {
      chartFilterData[c].title === val.value &&
        setChartDetail(chartFilterData[c])
    }
  }

  const getDropdownListChart = charts => {
    const listChart = []
    charts.pod.data.length > 1 && listChart.push(charts.pod)
    charts.driver.data.length > 1 && listChart.push(charts.driver)
    return listChart
  }

  const checkShowingToogleOption = index => {
    let result
    switch (index) {
      case TOGGLE_INDEX.MARKET_VALUE_OF_ASSET:
        result = charts.driver.data.some(obj => obj.asset_market_value && obj.asset_market_value !== "null")
        break
      case TOGGLE_INDEX.ASSET_VOLATILITY:
        result = charts.driver.data.some(obj => obj.asset_volatility && obj.asset_volatility !== "null")
        break
      case TOGGLE_INDEX.LEVERAGE:
        result = charts.driver.data.some(obj => obj.leverage && obj.leverage !== "null")
        break
      case TOGGLE_INDEX.PEER_GROUP:
        result = charts.pod.data.some(obj => obj.peer_pod && obj.peer_pod !== "null")
        break
      default:
        result = true
        break
    }
    return result
  }

  const chartDiv = useMemo(
    () => (chart, inModal, podToggleObj, driverToggleObj) => {
      const lineKeys = chart?.lineKeys
      return (
        <Grid
          key={chart.id}
          id={chart.id}
          item
          xs={12}
          sm={12}
          className={classes.chartDiv}
        >
          {/* selection !== null && chart.id !== undefined && selection.id === chart.id && <Snackbar message={message} id={selection.id}/> */}
          {chart.id !== 'impliedRating' && (
            <div className={classes.chartHeader}>
              <div className={classes.subheading}>
                {chart.title}
                <HelpRounded
                    className={classes.toolTip}
                    key={chart.id}
                    onClick={() => handleClickOpenTooltip(chart)}
                />
              </div>
              { chart?.subTitle && (<span className={classes.subTitle}>({chart.subTitle})</span>)}
              <div className={classes.help}>
                {inModal && (
                  <div>
                    <Typography className={classes.label}>View by</Typography>
                    <FilterBoxCommon
                      placeholder={chart.title}
                      data={getDropdownListChart(chartsData).map(item => {
                        return {
                          ...item,
                          value: item.title,
                        }
                      })}
                      selectedValue={chart.title}
                      setFilterValue={val => handleChangeViewBy(val)}
                      isSearch={false}
                      isRadio
                      customStyle={{ width: 200 }}
                      customStyleBody={{ width: 200 }}
                      outSelectedItems={[]}
                    />
                  </div>
                )}
                {!inModal && !isMobile && (
                  <img
                    src={expandIcon}
                    onClick={() => handeExpandChart(chart)}
                    className={`${classes.expandIcon} tooltip`}
                    id={`expandChartBtn-chart-${chart.id}`}
                  />
                )}
              </div>
            </div>
          )}
          {chart.id === 'pod' && (
            <>
              <div className={!inModal ? classes.podToggle : ''}>
                <ChartD3ToggleGroup
                  setToggleObj={val => setPodToggleObj(val)}
                  toggleObj={podToggleObj}
                  inModal={inModal}
                  showPeerGroup={checkShowingToogleOption(
                    TOGGLE_INDEX.PEER_GROUP,
                )}
                  showCompany
                  showEquityPrice
                  chartId={chart.id}
                />
              </div>
              <div
                className={
                  !inModal ? classes.smallLineChart : classes.fullLineChart
                }
              >
                <PoDChart
                  key={chart.id}
                  lineKeys={lineKeys}
                  inModal={inModal}
                  chartId={chart.id}
                  data={chart.data}
                  relations={chart}
                  setSelection={() => {}}
                />
              </div>
            </>
          )}

          {chart.id === 'impliedRating' && (
            <div className={classes.impliedRatingChartDiv}>
              <ImpliedRatingChart
                left={60}
                right={10}
                data={chart.data}
                inModal={inModal}
                chartId={chart.id}
              />
            </div>
          )}

          {chart.id === 'driver' && (
            <>
              <div className={!inModal ? classes.driverToggle : ''}>
                <ChartD3ToggleGroup
                  setToggleObj={val => setDriverToggleObj(val)}
                  toggleObj={driverToggleObj}
                  inModal={inModal}
                  showMarketValueOfAssets={checkShowingToogleOption(
                    TOGGLE_INDEX.MARKET_VALUE_OF_ASSET,
                  )}
                  showAssetVolatility={checkShowingToogleOption(
                    TOGGLE_INDEX.ASSET_VOLATILITY,
                  )}
                  showLeverage={checkShowingToogleOption(TOGGLE_INDEX.LEVERAGE)}
                  chartId={chart.id}
                />
              </div>
              <div
                className={
                  !inModal ? classes.smallLineChart : classes.fullLineChart
                }
              >
                <DriverChart
                  key={chart.id}
                  lineKeys={lineKeys}
                  inModal={inModal}
                  chartId={chart.id}
                  data={chart.data}
                  relations={chart}
                  setSelection={() => {}}
                />
              </div>
            </>
          )}
        </Grid>
      )
    },
    [state.creditData],
  )

  return (
    <PageSection
      title="Fundamentals - Credit Analysis"
      subTitle="Slower moving fair value-based credit assessment"
      fundamentalCreditTooltip
      isShowingRisk
      riskStatus={riskStatus}
    >
      {showImpliedRating && companyInfo && companyInfo.bfaiRating && (
        <>
          <div
            className={classes.filterYearContainer}
            // the id indicates this element is ignored when generating pdf
            id="filterByBox"
          >
            <div className={classes.title}>
              Implied Rating{' '}
              <span style={{ fontWeight: 600 }}>{companyInfo.bfaiRating}</span>
            </div>
          </div>
        </>
      )}
      <>
        <Grid className={classes.marketContextContainer} container spacing={3}>
          <Grid container>
            {chartsData.pod.data.length > 1 && (
              <Grid item xs={12} sm={12}>
                {chartDiv(chartsData.pod, false, podToggleObj, driverToggleObj)}
              </Grid>
            )}
            {chartsData.impliedRating.data.length > 1 && (
              <Grid item xs={12} sm={12}>
                {chartDiv(chartsData.impliedRating, false)}
              </Grid>
            )}
            {chartsData.driver.data.length > 1 && (
              <Grid item xs={12} sm={12}>
                {chartDiv(
                  chartsData.driver,
                  false,
                  podToggleObj,
                  driverToggleObj,
                )}
              </Grid>
            )}
          </Grid>
        </Grid>
        <PoDTooltipModal
          open={openTooltip === 'pod'}
          handleClose={() => {
            setOpenTooltip('')
          }}
          tooltipInfo={tooltipInfo}
        />
        <DriverTooltipModal
          open={openTooltip === 'driver'}
          handleClose={() => {
            setOpenTooltip('')
          }}
          tooltipInfo={tooltipInfo}
        />
        <ChartDialog
          chart={chartDiv(chartDetail, true, podToggleObj, driverToggleObj)}
          isOpenExpandModal={isOpenExpandModal}
          setOpenExpandModal={value => {
            d3.selectAll(`.line-chart${chartDetail.id}-inModal`).remove()
            d3.selectAll(`.stackarea-chart${chartDetail.id}-inModal`).remove()
            setOpenExpandModal(value)
          }}
        />
      </>
    </PageSection>
  )
}

export default FundamentalsCreditAnalysisMobile
